import { Card, Table } from "react-bootstrap";

function cmToFeetInches(cm) {
    const inchesTotal = cm / 2.54;
    const feet = Math.floor(inchesTotal / 12);
    const inches = (inchesTotal % 12).toFixed(0);

    return `${feet} FT. ${inches} In.`;
}

const ReferalListingObjects = ({ data, listingData, referalListingData }) => {
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    return (
        <Card>
            <Card.Body>
                <h6>Listing Details</h6>
                <div className="mt-4">
                    <Table striped bordered hover>
                        <tr>
                            <th>Listing Number</th>
                            <td>
                                {referalListingData?.referral_type === "buyer"
                                    ? listingData?.request_nb
                                    : listingData?.listing_number}
                            </td>
                        </tr>
                        <tr>
                            <th>Status</th>
                            <td>
                                {listingData?.status}
                            </td>
                        </tr>
                        <tr>
                            <th>Active / Inactive</th>
                            <td>
                                {listingData?.is_active}
                            </td>
                        </tr>
                    </Table>
                </div>
            </Card.Body>

        </Card>
    );

    return (
        <Card>
            <Card.Body>
                <h6>Listing Objects</h6>
                <div className="mt-4">
                    {data.map((object, index) => (
                        <Card key={object?.id}>
                            <Card.Header>{object?.type}</Card.Header>
                            <Card.Body>
                                {object?.type === "ReferralBoat" ? (
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Boat name</th>
                                                <th>Length</th>
                                                <th>Width</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{object?.boat_name ?? "N/A"}</td>
                                                <td>
                                                    {object?.referral_type === "seller"
                                                        ? cmToFeetInches(object?.length) ?? "N/A"
                                                        : `${object?.min_length ?? "N/A"} - ${object?.max_length ?? "N/A"
                                                        }`}
                                                </td>
                                                <td>
                                                    {object?.referral_type === "seller"
                                                        ? cmToFeetInches(object?.width) ?? "N/A"
                                                        : `${object?.min_width ?? "N/A"} - ${object?.max_width ?? "N/A"
                                                        }`}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                ) : null}
                            </Card.Body>
                        </Card>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default ReferalListingObjects;
